// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"2a729582","95":"98efae5a","208":"53f0fe1c","224":"90550bce","239":"a47ce104","288":"31b14bb1","367":"b0a9e8b8","407":"983d463c","528":"8bccc6a0","590":"42415a9b","625":"f236fc30","657":"e3dc9751","658":"a9b9270f","689":"5ba9d7e7","783":"45996838","927":"799bdbe0"}[chunkId] + ".chunk.js";
};